module.exports = __webpack_public_path__ + "static/media/internet-mobile.71320467.jpg";